export const sysop = {
    "apiLog": {
        "apiLog01": "Query Date",
        "apiLog02": "Status ",
        "apiLog03": "Send Ip",
        "apiLog04": "Request Path",
        "apiLog05": "Log Time"
    },
    "certificateBinding": {
        "certificateBinding01": "User",
        "certificateBinding02": "Token",
        "certificateBinding03": "Activation Status",
        "certificateBinding04": "Last Modify Date",
        "certificateBinding05": "Disable",
        "certificateBinding06": "Enable",
        "certificateBinding07": "CertificateBinding-Create",
        "certificateBinding08": "CertificateBinding-Update",
    },
    "empUser": {
        "empUser01": "User Id",
        "empUser02": "User Name",
        "empUser03": "User Email",
        "empUser04": "Password",
        "empUser05": "Check Password",
        "empUser06": "Role List",
        "empUser07": "'Password' and 'Check Password' no equal.",
        "empUser08": "User-Create",
        "empUser09": "User-Update"
    },
    "dimRole": {
        "dimRole01": "Role Code",
        "dimRole02": "Role Name",
        "dimRole03": "Rright List",
        "dimRole04": "dimRole-Create",
        "dimRole05": "dimRole-Update"
    },
    "accRightMan": {
        "accRightMan01": "Load Default Settings",
        "accRightMan02": "Account Restrictions",
        "accRightMan03": "最短長度:",
        "accRightMan04": "至少個字元",
        "accRightMan05": "Password Restrictions",
        "accRightMan06": "不可與帳號或使用者名稱相同",
        "accRightMan07": "密碼必須為文數字混合(英文大、小寫、數字、特殊符號四種須符合三種)",
        "accRightMan08": "不可含空白或特殊字元，只能用文字 A-Z 或數字 1-9 組成",
        "accRightMan09": "至少含",
        "accRightMan10": "個特殊字元",
        "accRightMan11": "相鄰二字元不可相同",
        "accRightMan12": "相鄰三字元不可為連續升冪或降冪",
        "accRightMan13": "不可與最近",
        "accRightMan14": "次內重複",
        "accRightMan15": "Account Closure Principle",
        "accRightMan16": "停用",
        "accRightMan17": "啟用",
        "accRightMan18": "同一天密碼連續錯誤",
        "accRightMan19": "次，帳號鎖定",
        "accRightMan20": "分鐘",
        "accRightMan21": "同一天密碼非連續錯誤"
    },
    "dimRight": {
        "dimRight01": "Rright Id",
        "dimRight02": "Rright Name",
        "dimRight03": "Function List",
        "dimRight04": "Right-Create",
        "dimRight05": "Right-Update"
    },
    "setFunction": {
        "setFunction01": "Add Group",
        "setFunction02": "Set Sortorder",
        "setFunction03": "Function Group",
        "setFunction04": "Function Id",
        "setFunction05": "Function Name",
        "setFunction06": "Sort",
        "setFunction07": "Url",
        "setFunction08": "Function-Create",
        "setFunction09": "Function-Update"
    },
    "empAgent": {
        "empAgent01": "Agent Account",
        "empAgent02": "Agent Period",
        "empAgent03": "Set Up Agent Account",
        "empAgent04": "Agent Start Date",
        "empAgent05": "Agent End Date",
        "empAgent06": "Agent-Create"
    },
    "empOrg": {
        "empOrg01": "Org Name",
        "empOrg02": "Org Id",
        "empOrg03": "Upper Org",
        "empOrg04": "Owned User",
        "empOrg05": "Org-Create",
        "empOrg06": "Org-Update",
    },
    "setParam": {
        "setParam01": "Update Parameter",
        "setParam02": "Parameter Id",
        "setParam03": "Parameter",
        "setParam04": "MEMO",
        "setParam05": "Create Parameter Category",
        "setParam06": "Create Parameter",
        "setParam07": "Update Parameter Category",
        "setParam08": "Parameter Category Id",
        "setParam09": "Parameter Category",
        "setParam10": "Function Category Id",
        "setParam11": "Function Name",
        "setParam12": "Flow Description",
        "setParam13": "Parameter Value",
        "setParam14": "Parameter-Parameter Create",
        "setParam15": "Parameter-Parameter Update",
        "setParam16": "Parameter-Parameter Category Create",
        "setParam17": "Parameter-Parameter Category Update",
    },
    "sqlLog": {
        "sqlLog01": "Query Date",
        "sqlLog02": "User",
        "sqlLog03": "Code Path",
        "sqlLog04": "Log Time"
    },
    "speedEditor": {
        "button01": "Export to Word",
        "button02": "Export to PDF"
    }
}